export type TemplateEditorStepKey = "senderRecipients" | "chooseTemplate" | "editor";

export interface TemplateCampaignDetails {
  campaignName: string;
  subjectLine: string;
}

export const TEMPLATE_EDITOR_KEY = "campaignFlow.templateEditor";

export const TEMPLATE_EDITOR_STEPS: { key: TemplateEditorStepKey; titleKey: string }[] = [
  { key: "senderRecipients", titleKey: "campaignFlow.aiWizard.steps.senderRecipients" },
  { key: "chooseTemplate", titleKey: `${TEMPLATE_EDITOR_KEY}.steps.chooseTemplate` },
  { key: "editor", titleKey: `${TEMPLATE_EDITOR_KEY}.steps.editor` },
];

export type EmailTemplateStepKey = TemplateEditorStepKey | "campaignDetails";

export const EMAIL_TEMPLATE_WIZARD_STEPS: { key: EmailTemplateStepKey; titleKey: string }[] = [
  { key: "campaignDetails", titleKey: "campaignFlow.aiWizard.steps.campaignDetails" },
  ...TEMPLATE_EDITOR_STEPS,
];

export const TEMPLATES_PAGE_SIZE = 8;
export const DEFAULT_BLANK_TEMPLATE_ID = "blank";
export const PREVIEW_MODAL_WIDTH = 720;
